import { useState } from "react";
import { Link } from "react-router-dom";
import { LocateFixed, MapPin, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import LocationPicker from "@/components/LocationPicker";

export default function LocationAsk({ onLoc }) {
  const [manual, setManual] = useState(false);
  const [sel, setSel] = useState({ city: "", neighborhood: "" });
  const [loading, setLoading] = useState(false);
  const gps = () => {
    if (!navigator.geolocation) { setManual(true); return; }
    setLoading(true);
    navigator.geolocation.getCurrentPosition(
      async (pos) => {
        const loc = { mode: "gps", lat: pos.coords.latitude, lng: pos.coords.longitude };
        try { Object.assign(loc, (await api.post("/locate", { lat: loc.lat, lng: loc.lng })).data); } catch (e) {}
        setLoading(false);
        onLoc(loc);
      },
      () => { setLoading(false); setManual(true); toast("Tudo bem! Escolha sua cidade e bairro."); },
      { enableHighAccuracy: false, timeout: 15000, maximumAge: 300000 }
    );
  };
  return (
    <div className="po-card" data-testid="location-ask">
      <h2 className="font-display text-xl font-bold text-slate-900">Onde você está?</h2>
      <p className="mt-1 text-lg text-slate-700">
        Usamos sua localização só para mostrar quem está mais perto. <Link to="/privacidade" className="font-semibold text-orange-600 underline">Saiba mais</Link>
      </p>
      {!manual ? (
        <div className="mt-4 grid gap-3 sm:grid-cols-2">
          <button onClick={gps} disabled={loading} className="po-btn-primary" data-testid="use-gps-button">
            {loading ? <Loader2 className="h-6 w-6 animate-spin" /> : <LocateFixed className="h-6 w-6" />} Usar minha localização
          </button>
          <button onClick={() => setManual(true)} className="po-btn-outline" data-testid="choose-manual-button">
            <MapPin className="h-6 w-6" /> Escolher cidade e bairro
          </button>
        </div>
      ) : (
        <div className="mt-4">
          <LocationPicker city={sel.city} neighborhood={sel.neighborhood} onChange={setSel} prefix="search" />
          <button disabled={!sel.city || !sel.neighborhood} onClick={() => onLoc({ mode: "manual", ...sel })} className="po-btn-primary mt-4 w-full" data-testid="manual-location-confirm">
            Confirmar local
          </button>
        </div>
      )}
    </div>
  );
}
